import React from 'react'
import { v4 as uuidv4 } from 'uuid';

const SingleLanguage = (props) => {
    return (<>
        <div className="flex-container mt-6">
            <p className="para-text">{props.name}</p>
            <p className="italicstyling">{props.percentage}</p>
        </div>
    </>
    )
}


function Languages(props) {
    return (
        <>
            <p className="heading-text mt-15">LANGUAGES</p>
            <div className="language-container">
                {
                    props.languages.map((element)=>{
                        return <SingleLanguage key={uuidv4()} {...element}/>
                    })
                }
            </div>
        </>
    )
}

export default Languages
